Flup.service("countdown", function(flup) {

    this.start = function($elm, secondsLeft) {
		var itv,
			$d = $elm.find("[data-days]"),
			$h = $elm.find("[data-hours]"),
			$m = $elm.find("[data-minutes]"),
			$s = $elm.find("[data-seconds]"),
			daysRemoved = false;
		
		function countdownTick(){
			secondsLeft--;
			var days = 0, hours = 0, minutes = 0, seconds = 0;

			if (secondsLeft < 0) {
				clearInterval(itv);
				return;
			};
	
			days = Math.floor(secondsLeft / 86400);
			hours = Math.floor((secondsLeft - (days * 86400)) / 3600);
			minutes = Math.floor((secondsLeft - (days * 86400) - (hours * 3600)) / 60);
			seconds = Math.floor((secondsLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));
	
			if (hours < 10) hours = "0" + hours;
			if (minutes < 10) minutes = "0" + minutes;
			if (seconds < 10) seconds = "0" + seconds;

			$d.html(days);
			$h.html(hours);
			$m.html(minutes);
			$s.html(seconds);
		}
		itv = setInterval(countdownTick, 1000);
		countdownTick();
	}
	
});

Flup.link("countdown", function(flup, $elm, value) {
    flup("countdown").start($elm, parseFloat(value));
});